module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.visible) ? _c('mt-header', {
    attrs: {
      "title": _vm.routeName,
      "backgroundColor": "mt-bg-theme",
      "color": "mt-color-white",
      "fixed": ""
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/"
    },
    slot: "left"
  }, [_c('span', {
    staticClass: "iconfont icon-keyboardarrowleft"
  })])], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ff82ca9","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/app.vue
// module id = 91
// module chunks = 0